import type { Slide as EditorSlide } from '../../compatibility-overrides/editor-types';
import type { Slide as PresentationSlide } from '../../compatibility-overrides/presentation-types';

export const commonSlidePropertyKeys = [
  'design',
  'images',
  'instructionsBarVisibility',
  'interactiveContents',
  'qrCodeVisibility',
  'responseVisibility',
  'slideAdminKey',
  'slideId',
  'slidePublicKey',
  'speakerNotes',
  'staticContent',
  'title',
  'visibility',
] as const satisfies Array<
  // TODO (Jon): add BaseSlide type?
  keyof (EditorSlide | PresentationSlide)
>;
